import React, { Component } from 'react';
import _ from 'lodash';
import { setAsyncRouteLeaveHook } from '../../pages/manage/utils';
import { AsyncUnsavedChangesModal } from '../AsyncUnsavedChangesModal';

export class OnLeaveSaveFileDialog extends Component {
    state = {
        removeLeaveHook: null
    };

    componentWillMount() {
        this.setState({
            removeLeaveHook: setAsyncRouteLeaveHook(this.props.router, this.props.route, this.routerWillLeave)
        });
    }

    componentWillUnmount() {
        this.state.removeLeaveHook && this.state.removeLeaveHook();
    }

    routerWillLeave = () => {
        return new Promise(resolve => {
            if (!this.props.fileChanged) {
                setTimeout(() => {
                    resolve({ finalResult: true });
                }, 200);
            } else {
                this.dialogRef.ask(
                    () => {
                        resolve({
                            finalResult: true,
                            stayOnSamePage: !this.props.shouldLeavePageOnCancel
                        });
                        this.props.onPageLeave();
                    },
                    () => {
                        resolve({
                            finalResult: false
                        });
                    }
                );
            }
        });
    };

    render() {
        return (
            <AsyncUnsavedChangesModal
                ref={node => (this.dialogRef = node)}
                level={this.props.level}
                chainId={this.props.chainId}
                hotelId={this.props.hotelId}
                titleName={this.props.titleName}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/modals/editFile/OnLeaveSaveFileDialog.js